import { path, propOr } from 'ramda';
import { createSelector } from 'reselect';

import { EMPTY_VALUES } from 'constants/general';

import { NAME } from './constants';

const getRoot = path([NAME]);

export const getMarketPlaceLeads = createSelector(getRoot, propOr(EMPTY_VALUES.ARRAY, 'leads'));

export const getSortValue = createSelector(getRoot, propOr(EMPTY_VALUES.STRING, 'customSort'));

export const getAvailableLeads = createSelector(getRoot, propOr(EMPTY_VALUES.ARRAY, 'availableLeads'));

export const getQuickFilterState = createSelector(getRoot, propOr(EMPTY_VALUES.STRING, 'quickFilter'));

export const getSelectedDayOfNextDays = createSelector(getRoot, propOr(EMPTY_VALUES.STRING, 'selectedNextDay'));

export const getSearchedWithCustomFilter = createSelector(getRoot, propOr(false, 'searchedWithCustomFilter'));

export const getOnDetailThroughMarketPlaceRow = createSelector(getRoot, propOr(false, 'onDetailThroughMarketPlaceRow'));

export const getSelectedInProgressTaskTypeId = createSelector(getRoot, propOr(null, 'selectedInProgressTaskTypeId'));

export const getInProgressAndAfterDeadlineLeadOverview = createSelector(
	getRoot,
	propOr(EMPTY_VALUES.ARRAY, 'inProgressAndAfterDeadlineLeadOverview'),
);

export const getInProgressAndAfterDeadLineLeads = createSelector(
	getRoot,
	propOr(EMPTY_VALUES.OBJECT, 'inProgressAndAfterDeadlineLeads'),
);

export const getInProgressLeadsByTaskTypeId = createSelector(
	getInProgressAndAfterDeadLineLeads,
	(state, taskTypeId) => taskTypeId,
	(leads, taskTypeId) => propOr(EMPTY_VALUES.ARRAY, taskTypeId)(leads),
);
